import { render } from "./CostiTimesheetSottoprogetto.vue?vue&type=template&id=8bb46552&scoped=true&ts=true"
import script from "./CostiTimesheetSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./CostiTimesheetSottoprogetto.vue?vue&type=script&lang=ts"

import "./CostiTimesheetSottoprogetto.vue?vue&type=style&index=0&id=8bb46552&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb46552"]])

export default __exports__